import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatButton from './components/ChatButton';
import Home from './pages/Home';
import WhatWeOffer from './pages/WhatWeOffer';
import Industries from './pages/Industries';
import About from './pages/About';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import Apply from './pages/Apply';
import Partner from './pages/Partner';
import Login from './pages/Login';
import Merchandise from './pages/Merchandise';

function ScrollToTop() {
  const { pathname, search } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  return null;
}

function Layout() {
  const { pathname } = useLocation();
  const hideFooter = pathname === '/login';
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-we-offer" element={<WhatWeOffer />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/merchandise" element={<Merchandise />} />
        <Route path="/merchandize" element={<Merchandise />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
      <ChatButton />
    </BrowserRouter>
  );
}
